// client/src/pages/canvas/AngleSetDoc.tsx
// v6.78 — the chat Angles doc is the EXISTING Ad Angles set view, not a
// reinvention (Dan: "we already have working sheets that are EDITABLE in ad
// angles… that's what this concepts preview doc should look like"). This is
// a thin shell: resolve the set's brandId, then mount the SAME SetDetail
// component the Brands tab uses — editable copy drawer, per-stage Build
// buttons, add-angle, rename, all of it. "Back" closes the sidebar panel.
import { useQuery } from '@tanstack/react-query';
import { briefQueryOptions } from './brief-query';
import { Loader2 } from 'lucide-react';
import { SetDetail } from '@/components/brands/AdAnglesPanel';
import { useCanvasStore } from './canvas-store';

export function AngleSetDoc({ setId, ownerProjectId }: { setId: number; ownerProjectId?: number | null }) {
  const closeSidebarPanel = useCanvasStore((s) => s.closeSidebarPanel);

  // Same queryKey as SetDetail's own fetch — shares the cache entry, so this
  // resolves brandId without a duplicate request.
  const { data, isLoading, isError, refetch, isFetching } = useQuery(briefQueryOptions(setId));

  if (isLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 60, gap: 8, color: '#B0ACA6', fontSize: 13 }}>
        <Loader2 style={{ width: 16, height: 16 }} className="animate-spin" /> Loading angle set…
      </div>
    );
  }
  if (isError || !data?.set) {
    return <div style={{ padding: '48px 28px', textAlign: 'center', color: '#B5B0A8', fontSize: 14 }}>{isError ? "Couldn't load this ad brief." : 'This ad brief is no longer available.'}
      {isError && <button type="button" disabled={isFetching} onClick={() => void refetch()} style={{ display: 'block', margin: '12px auto', textDecoration: 'underline' }}>{isFetching ? 'Loading…' : 'Retry'}</button>}
    </div>;
  }

  return (
    <div className="brand-content" data-testid="angle-set-doc" style={{ padding: '16px 22px 40px' }}>
      <SetDetail brandId={data.set.brandId} setId={setId} originProjectId={ownerProjectId} onBack={closeSidebarPanel} docMode onBuildStarted={closeSidebarPanel} />
    </div>
  );
}
